import { nanoid } from 'nanoid';
import { Filter } from '@/containers/bookings/types';

// Required filters that must survive "Clear filters"
export const createDefaultFilters = (): Filter<any>[] => [
    {
        id: nanoid(),
        operator: 'ascending',
        type: 'OrderBy',
        value: 'CreatedDate',
        criteria: '',
        required: true,
    },
    {
        id: nanoid(),
        operator: 'Is',
        type: 'Single',
        value: '',
        label: 'Company Id',
        criteria: 'CompanyId',
        required: true,
    },
];

export const hasDefaultFilters = (filters?: Filter<any>[]) =>
    Array.isArray(filters) && filters.some((f) => f.type === 'OrderBy');
